let convertToArray = function (nodeList) {
    return [].slice.call(nodeList);
}
let accordionLists: Array<any> = convertToArray(document.querySelectorAll('[data-accordion-list]'));
let resizeTimer;
const openClass = 'libaccordion-open-js'; 
const openClassCss = 'libaccordion-open';
class AccordionsOptions {
    singleAccordion: boolean = false;
}
export class Accordions {
    options: AccordionsOptions = new AccordionsOptions();
    constructor(private optArg?: any) {
        window.addEventListener('resize', () => {
            requestAnimationFrame(this.triggerSetAccordionHeights.bind(this));
        });
        accordionLists.forEach((accordionList) => {
            accordionList.addEventListener("click", this.accordionClick.bind(this), false);
        });
        //Check for Options
        if (this.optArg === undefined)
            this.optArg = new AccordionsOptions();
        else {
            this.options.singleAccordion = (this.optArg.singleAccordion === undefined) ? this.options.singleAccordion : this.optArg.singleAccordion;
        }
    }
    setAccordionHeights() {
        setTimeout(function () {
            accordionLists.forEach((accordionList) => {
                let openAccordions = accordionList.querySelectorAll('.' + openClass);
                if (openAccordions.length > 0) {
                    openAccordions.forEach((openAccordion) => {
                        let accordionToReCalc = openAccordion.querySelector('[data-accordion-content-id]');
                        let accordionRecalcedHeight = accordionToReCalc.getBoundingClientRect().height;
                        console.log(accordionRecalcedHeight);
                        openAccordion.style.height = accordionRecalcedHeight + 'px';
                    });
                }
            });
        }, 100);
    }
    accordionClick(e) {
        if (e.target !== e.currentTarget) {
            let accordionToOpenId = e.target.getAttribute('data-accordion-trigger');
            if (accordionToOpenId === null) {
                accordionToOpenId = e.target.parentElement.getAttribute('data-accordion-trigger');
            }
            let accordionToToggle = document.querySelector('[data-accordion-id="' + accordionToOpenId + '"]');
            let accordionContentHeight = document.querySelector('[data-accordion-content-id="' + accordionToOpenId + '"]').getBoundingClientRect().height;
            if (this.options.singleAccordion) {
                this.closeOpenAccordions(accordionToToggle);
            }
            if (accordionToToggle.classList.contains(openClass)) {
                this.closeAccordion(accordionToToggle);
            }
            else {
                this.openAccordion(accordionToToggle, accordionContentHeight);
            }
            this.setAccordionHeights();
        }
        e.stopPropagation();
    }
    openAccordion(accordionToOpen, accordionToOpenHeight) {
        if (accordionToOpen.parentElement.classList.contains("libaccordion-show-multiple-false")) {
            let parentContainer = accordionToOpen.parentElement.parentElement;
            let collapsableItems = Array.prototype.slice.call(parentContainer.querySelectorAll(".libaccordion-show-multiple-false"));
            collapsableItems.forEach(function (item) {
                if (item.classList.contains("libaccordion-open")) {
                    item.classList.remove("libaccordion-open");
                }
                if (item.querySelector(".libaccordion-content").classList.contains("libaccordion-open-js")) {
                    item.querySelector(".libaccordion-content").classList.remove("libaccordion-open-js");
                    item.querySelector(".libaccordion-content").setAttribute('style', 'height: 0px;');
                    item.querySelector(".libaccordion-content").setAttribute('aria-hidden', 'true');
                } 
            })        
        }

        accordionToOpen.classList.add(openClass);
        accordionToOpen.setAttribute('style', 'height:' + accordionToOpenHeight + 'px');
        accordionToOpen.setAttribute('aria-hidden', 'false');
        accordionToOpen.parentElement.classList.add(openClassCss);
    }
    closeAccordion(accordionToClose) { 
        accordionToClose.classList.remove(openClass);
        accordionToClose.setAttribute('style', 'height: 0px');
        accordionToClose.setAttribute('aria-hidden', 'true');
        accordionToClose.parentElement.classList.remove(openClassCss);
    }
    triggerSetAccordionHeights() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
            this.setAccordionHeights();
        }, 100);
    }
    closeOpenAccordions(exception) {
        let openAccordions = convertToArray(document.querySelectorAll('.libaccordion-open-js'));
        openAccordions.forEach((openAccordion) => {
            if (openAccordion !== exception) {
                this.closeAccordion(openAccordion);
            }
        });
    }
}


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./Lib/Lib-Javascript/accordion/accordions.ts